import React from 'react';
import PropTypes from 'prop-types';
import AssociatedBlockComponent from './AssociatedBlockComponent';
import { getContent } from '../../utils/formatValue';
const AssociatedItemsList = ({
    items,
    icon,
    primaryTitle,
    secondaryTitle,
    onRemove,
    primaryKey,
    secondaryKey,
    primaryType,
    secondaryType,
    hideSecondaryLabel,
    hidePrimaryLabel,
    stackValues
}) => {
    if (!items || items.length === 0) {
        return null;
    }

    return items.map((item, index) => (
        <AssociatedBlockComponent
            key={index}
            icon={icon}
            primaryTitle={primaryTitle}
            secondaryTitle={secondaryTitle}
            hideSecondaryLabel={hideSecondaryLabel}
            hidePrimaryLabel={hidePrimaryLabel}
            stackValues={stackValues}
            primaryContent={getContent(item, primaryKey, primaryType)}
            secondaryContent={getContent(item, secondaryKey, secondaryType)}
            action={{
                label: 'Remove',
                onClick: () => onRemove(item.id)
            }}
        />
    ));
};

AssociatedItemsList.propTypes = {
    items: PropTypes.array.isRequired,
    icon: PropTypes.node.isRequired,
    primaryTitle: PropTypes.string,
    secondaryTitle: PropTypes.string,
    onRemove: PropTypes.func.isRequired,
    primaryKey: PropTypes.string.isRequired,
    secondaryKey: PropTypes.string,
    primaryType: PropTypes.string,
    secondaryType: PropTypes.string,
    hideSecondaryLabel: PropTypes.bool,
    hidePrimaryLabel: PropTypes.bool,
    stackValues: PropTypes.bool
};

export default React.memo(AssociatedItemsList);
